import React, {Fragment} from 'react';
import {Link, NavLink} from 'react-router-dom';
import history from '../../history';
import SocialLinks from '../sessions/SocialLinks';
import {userInfo} from 'os';
import logo from '../../images/logo6.png';
import './Slidebar.css';

function Slidebar({items = [], user = {}, isVisible, onHide}) {
	return (
		<>
			{/* Backdrop overlay */}
			{isVisible && (
				<div 
					className="slide-backdrop" 
					onClick={onHide}
					aria-hidden="true"
				/>
			)}
			
			{/* Sidebar */}
			<div className={`slide-nav slide d-md-none ${isVisible ? 'show' : 'closed'}`}>
				{/* Header with logo and close button */}
				<div className="slide-nav-header">
					<Link to="/" onClick={onHide} className="slide-nav-logo">
						<img src={logo} alt="Visit All Nepal" />
					</Link>
					<button 
						className="slide-nav-close" 
						onClick={onHide}
						aria-label="Close menu"
					>
						<i className="icon-cross" />
					</button>
				</div>
				
				{/* Menu items */}
				<div className='slide-nav-content'>
					<div className='ui relaxed divided list'>
						{items.map(({label, name, details = null, icon, value, link, ...rest}, index) => (
							<Fragment key={index}>
								<div
									className='slide-nav-item'
									key={name}
									onClick={() => {
										if (link.startsWith('tel:') || link.startsWith('mailto:')) {
											window.location.href = link;
										} else if (link.startsWith('http://') || link.startsWith('https://')) {
											window.open(link, '_blank');
										} else {
											history.push(link);
										}
										onHide();
									}}
								>
									<i className={`large icon ${icon} slide-nav-icon`} />
									<div className='slide-nav-item-content'>
										<div className='slide-nav-item-label'>{label}</div>
										{(details || value) && (
											<div className='slide-nav-item-details'>
												{details}
												{value}
											</div>
										)}
									</div>
								</div>
							</Fragment>
						))}
					</div>
					{!user.id && (
						<div className="slide-nav-social">
							<SocialLinks />
						</div>
					)}
				</div>
			</div>
		</>
	);
}

export default Slidebar;
